export default __webpack_public_path__ + "static/media/menu_pools.3996f3f3.svg";